export const endpoints = {
    presentation: 'api/v1/presentation',
}
